import React from 'react'

function Footer() {
  return (
    <footer className="site-footer">
      © 2025 BackToTheRoots - Tutti i diritti riservati
    </footer>
  )
}

export default Footer
